var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXpayActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1726,
    height: 693,
    viewBox: "0 0 1726 693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 519.771V558.262H38.4913L172.37 424.383V385.892H133.879L0 519.771Z",
    fill: "#0085FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.392 385.892V424.383L376.293 558.262H414.762V519.771L280.883 385.892H242.392Z",
    fill: "#0085FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.392 277.383V315.875H280.883L414.762 181.996V143.526H376.293L242.392 277.383Z",
    fill: "#0085FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 143.526V181.996L133.879 315.875H172.37V277.383L38.4913 143.526H0Z",
    fill: "#0085FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.1 693.005H1379.52V622.939H1414.17C1454.21 622.939 1471.15 619.859 1489.63 565.963L1494.25 555.953L1344.11 144.029H1444.2L1538.13 441.23L1632.07 144.029H1726L1580.48 557.493C1541.21 664.516 1514.27 693.005 1421.1 693.005Z",
    fill: "#0085FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.42 199.466V144.029H1323.05V558.263H1231.42V503.597C1206.78 544.404 1163.67 568.273 1108.23 568.273C1004.29 568.273 928.06 484.348 928.06 351.146C928.06 217.945 1004.29 134.79 1108.23 134.79C1163.67 134.79 1206.78 158.658 1231.42 199.466ZM1235.27 351.146C1235.27 255.672 1187.53 209.475 1128.25 209.475C1060.49 209.475 1023.53 262.602 1023.53 351.146C1023.53 439.691 1060.49 493.587 1128.25 493.587C1187.53 493.587 1235.27 446.62 1235.27 351.146Z",
    fill: "#0085FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M513.754 0.0488281H697.773C820.195 0.0488281 934.918 19.2976 934.918 175.598C934.918 316.499 830.974 347.297 699.313 347.297H611.538V558.264H513.754V0.0488281ZM697.773 78.5839H611.538V267.222H702.392C776.308 267.222 833.284 256.443 833.284 176.368C833.284 86.2834 766.298 78.5839 697.773 78.5839Z",
    fill: "#0085FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpayActive);
export default __webpack_public_path__ + "static/media/xpay-active.f8c80345cf2baa59fb384741b1300dd5.svg";
export { ForwardRef as ReactComponent };